/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderItemGroupModifierSchema } from "./mobileOrderItemGroupModifierSchema.ts";
import { mobileOrderItemModifierSchema } from "./mobileOrderItemModifierSchema.ts";
import { mobileOrderItemPaidBySchema } from "./mobileOrderItemPaidBySchema.ts";
import { mobileOrderItemSizeSchema } from "./mobileOrderItemSizeSchema.ts";
import { mobileOrderItemTypeEnumSchema } from "./mobileOrderItemTypeEnumSchema.ts";
import { portionNutritionSchema } from "./portionNutritionSchema.ts";
import { userProfileCardSchema } from "./userProfileCardSchema.ts";

export const mobileOrderItemSchema = z.object({
	id: z.uuid(),
	product_id: z.uuid().nullable(),
	amount: z.number(),
	size: mobileOrderItemSizeSchema.nullable(),
	correlation_id: z.uuid().nullish(),
	expected_cooking_time: z.int().nullable(),
	image_link: z.string().nullable(),
	name: z.string().nullable(),
	price: z.number().nullable(),
	type: mobileOrderItemTypeEnumSchema.nullable(),
	cooking_state: z.int().nullable(),
	cooking_time: z.int().nullable(),
	user: userProfileCardSchema.nullish(),
	total_cost: z.number(),
	applied_combo: z.uuid().nullish(),
	comment: z.string().max(255).nullish(),
	nutrition: portionNutritionSchema.nullable().describe("Вес и КБЖУ порции"),
	is_paid: z.boolean().optional(),
	paid_by: mobileOrderItemPaidBySchema.nullable().describe("Информация о пользователе, оплатившем позицию."),
	modifiers: z.array(mobileOrderItemModifierSchema),
	group_modifiers: z.array(mobileOrderItemGroupModifierSchema),
});
